module.exports = __webpack_public_path__ + "static/media/3_r_stol_47.29_76.39.c99bb4d4.png";